window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.transcriptsBox = window.locales.am.transcriptsBox || {};window.locales.am.transcriptsBox = {...window.locales.am.transcriptsBox, ...{
    "heading": "የውጤት ወረቀቶች",
    "content": "የእርስዎ Quantic የውጤት ወረቀት ኦፊሺያል ወይም ኦፊሻል ያልሆነ ቅጂ ያስፈልግዎታል?",
    "buttonLearnMore": "ተጨማሪ ይወቁ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.transcriptsBox = window.locales.ar.transcriptsBox || {};window.locales.ar.transcriptsBox = {...window.locales.ar.transcriptsBox, ...{
    "heading": "كشوف الدرجات",
    "content": "هل تحتاج إلى نسخة رسمية أو غير رسمية من كشف درجاتك في Quantic؟",
    "buttonLearnMore": "اعرف المزيد"
}
};window.locales.en = window.locales.en || {};window.locales.en.transcriptsBox = window.locales.en.transcriptsBox || {};window.locales.en.transcriptsBox = {...window.locales.en.transcriptsBox, ...{
    "heading": "Transcripts",
    "content": "Do you need an official or unofficial copy of your Quantic transcript?",
    "buttonLearnMore": "Learn More"
}
};window.locales.es = window.locales.es || {};window.locales.es.transcriptsBox = window.locales.es.transcriptsBox || {};window.locales.es.transcriptsBox = {...window.locales.es.transcriptsBox, ...{
    "heading": "Transcripciones",
    "content": "¿Necesitas una copia oficial o no oficial de tu transcripción de Quantic?",
    "buttonLearnMore": "Más Información"
}
};window.locales.it = window.locales.it || {};window.locales.it.transcriptsBox = window.locales.it.transcriptsBox || {};window.locales.it.transcriptsBox = {...window.locales.it.transcriptsBox, ...{
    "heading": "Trascrizioni",
    "content": "Hai bisogno di una copia ufficiale o non ufficiale della tua trascrizione Quantic?",
    "buttonLearnMore": "Scopri di Più"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.transcriptsBox = window.locales.zh.transcriptsBox || {};window.locales.zh.transcriptsBox = {...window.locales.zh.transcriptsBox, ...{
    "heading": "成绩单",
    "content": "您需要Quantic成绩单的官方或非官方副本吗？",
    "buttonLearnMore": "了解更多"
}
};